export default __webpack_public_path__ + "static/media/ico-mail.80dafa79.svg";